import React, { useContext, useMemo, useRef } from 'react';
import CommunityCard from './CommunityCard';
import LoadingCard from '../Loading/LoadingCard';
import { CommunitiesContext } from '../../context/CommunitiesContext';
import useSlides from '../../hooks/useSlides';
import useWindowSize from '../../hooks/useWindowSize';

export default function CommunitiesSlider() {
  const communitySliderRef = useRef(null);
  const { width } = useWindowSize();
  const isMobile = width <= 768;

  const { communities, city } = useContext(CommunitiesContext);

  const slideCount = useSlides({
    sliderRef: communitySliderRef,
    cardWidth: 215,
  });

  const loadingCards = useMemo(
    () =>
      [...Array(slideCount)].map((_, ind) => (
        <LoadingCard key={ind} card_type="community" />
      )),
    [slideCount]
  );

  return (
    <div ref={communitySliderRef} className="community-slider-container">
      {communities
        ? communities
            .slice(0, isMobile ? 2 : slideCount)
            .map((community, ind) => (
              <CommunityCard key={ind} community={community} area={city} />
            ))
        : loadingCards}
    </div>
  );
}
